//===============================
// Colors
//===============================

// TODO: tighten when domain types exist — `colors` was referenced but never defined in the original JS
 
declare const colors: string[]

/**
 * Convert hex color string to [r, g, b] tuple.
 *
 * @param hexValue - CSS hex color string (with or without leading #)
 * @returns Tuple of [r, g, b] integers, or null if the string is not a valid hex color
 */
export const hexToRgb = (hexValue: string): [number, number, number] | null => {
    let hex: string
    if (hexValue.indexOf('#') === 0) {
        hex = hexValue.substring(1)
    } else {
        hex = hexValue
    }
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
        hex.replace(shorthandRegex, (_m, r: string, g: string, b: string) => r + r + g + g + b + b),
    )
    return result
        ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
        : null
}

export const rgbColor = (color = colors[0]): string => `rgb(${hexToRgb(color)})`
export const rgbaColor = (color = colors[0], alpha = 0.5): string => `rgba(${hexToRgb(color)},${alpha})`
